export const generateApplyFilterSetToAccountFixedCacheKey = (
  accountId?: string | void,
) => {
  return `postUsersMeAccountsByAccountIdFiltersV2+${accountId}`;
};
